import './component-hooks';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/scss/index.scss';
import VueCurrencyInput from 'vue-currency-input';
import VueGtag from 'vue-gtag';
import './hack';

Vue.use(VueCurrencyInput, {
  globalOptions: { locale: 'en-AU', currency: 'AUD' },
});

Vue.config.productionTip = false;

Vue.use(VueGtag, {
  config: { id: 'G-7TXDY8RWL3' },
  enabled: true,
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
